// @flow
import { createSelector } from 'reselect';

export const resourcesSelector = createSelector(
  state => state.resources,
  (resources: $ElementType<ReduxState, 'resources'>): $ElementType<ReduxState, 'resources'> =>
    resources
);

export const resourcesListSelector = createSelector(
  resourcesSelector,
  (resources): List => Object.keys(resources)
);
